import { useState } from 'react';

const faqItems = [
  {
    q: '丫丫影院的视频播放需要安装播放器吗？',
    a: '不需要安装任何播放器或插件。丫丫影院采用HTML5网页播放技术，打开浏览器即可直接观看最新电影和电视剧。无论是电脑、平板还是手机，都能实现流畅播放、不缓冲的观影体验。',
  },
  {
    q: '观看视频需要注册账号或付费吗？',
    a: '完全不需要。丫丫影院坚持高清免费的理念，所有最新影视资源均无需注册、无需付费、无需会员。即点即播，在线观看零门槛，让每一个人都能轻松享受流畅的观影体验。',
  },
  {
    q: '为什么有些视频会出现缓冲或卡顿？',
    a: '丫丫影院采用智能CDN加速技术，正常情况下最新电影不缓冲、最新电视剧流畅。如果遇到卡顿，建议（1）切换较低清晰度（2）检查网络连接（3）避开用网高峰期。我们持续优化传输节点，确保流畅播放体验。',
  },
  {
    q: '平台上的影视资源多久更新一次？',
    a: '我们的内容团队每日24小时监测各大平台，热播剧集和院线电影上线当日即同步最新更新。电视剧按播出进度逐集更新，电影资源在可获取后第一时间上线，确保你不错过任何精彩内容。',
  },
  {
    q: '遇到无法播放或链接失效怎么办？',
    a: '如果遇到播放问题，可以先尝试刷新页面或切换清晰度。如果问题持续存在，请通过联系投稿页面的邮箱或微信反馈给我们，技术团队会在第一时间排查修复，保障你的在线观看体验。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[720px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              常见问答
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              关于丫丫影院的常见问题，帮你快速了解我们
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="rounded-xl border border-background-200/60 bg-background-50 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer"
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                >
                  <h3 className="text-sm font-bold text-foreground-900 pr-2">{item.q}</h3>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${
                    openIdx === idx ? 'bg-primary-100 text-primary-600' : 'bg-background-200 text-foreground-400'
                  }`}>
                    <i className={`text-sm transition-transform duration-300 ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIdx === idx ? 'max-h-60' : 'max-h-0'
                  }`}
                >
                  <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}